import React from 'react';
import CurrencyValue from './CurrencyValue';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import useIsMobile from 'utils/isMobileUtils';

const QuickStatsBar = ({data, isLoading = true}) => {
    const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
	const total = data?.reduce((acc, item) => acc + (item.value?.[selectedCurrency] || 0), 0);
    const isMobile = useIsMobile();

	return (
		<>
			<div
				className="quick-stats-bar"
				style={{ display: 'flex', width: '100%', borderRadius: '2px', overflow: 'hidden', marginTop: '15px' }}
			>
                {data.map((item, index) => (
                    <>
                        <div
                            key={index}
                            className='quick-stats-bar-item'
                            style={{
                                '--width-item': `${(item.value?.[selectedCurrency] / total) * 100}%`,
                                backgroundColor: item?.color,
                                overflow: 'hidden',
                                height: '10px',
                                position: 'relative'
                            }}
                        >
                        </div>
                    </>
				))}
			</div>
			<div
                className="quick-stats-legend"
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    width: '100%',
                    marginTop: '10px',
                    flexWrap: 'wrap',
                    gap: '12px'
                }}
            >
                {data.map((item, index) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            minWidth: '48%',
                        }}
                    >
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                backgroundColor: item?.color,
                            }}
                        ></div>
                        <div
                            className="quick-stats-legend-text"
                            style={{
                                display: isMobile ? 'block' : 'flex',
                            }}
                        >
                            {
                                isLoading ? (
                                    <div
                                        style={{
                                            marginLeft: '10px',
                                            display: isMobile ? 'block' : 'flex',
                                        }}
                                    >
                                        {item?.name} 
                                        <div style={{ width: '100px', marginLeft: '10px' }}>
                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />  
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        style={{
                                            marginLeft: '10px',
                                            display: isMobile ? 'block' : 'flex',
                                        }}
                                    >
                                        {item?.name}
                                        <div style={{ marginLeft: isMobile ? '0px' : '10px' }}>
                                            <CurrencyValue currencyObject={item?.value} defaultCurrency={selectedCurrency.replace(/\s+/g, '') === 'all' ? 'usd' : selectedCurrency.replace(/\s+/g, '')} />
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                ))}
            </div>
		</>
	);
};

export default QuickStatsBar;
